import { render, staticRenderFns } from "./BuildingsTab.vue?vue&type=template&id=53f076bc&scoped=true"
import script from "./BuildingsTab.vue?vue&type=script&lang=js"
export * from "./BuildingsTab.vue?vue&type=script&lang=js"
import style0 from "./BuildingsTab.vue?vue&type=style&index=0&id=53f076bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f076bc",
  null
  
)

export default component.exports